export default __webpack_public_path__ + "static/media/award02.8bbdd514.png";